import { PlaceholderPage } from './PlaceholderPage';

export const FactorsPage = () => <PlaceholderPage title="Factors" />;
